/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Org_Models_Updated_DescInputs */



/**
* | output |
* | --- |
* | "The set of AI models members may choose from was changed." |
*
* @param {Audit_Details_Org_Models_Updated_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_org_models_updated_desc = /** @type {((inputs?: Audit_Details_Org_Models_Updated_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Org_Models_Updated_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Auswahl der KI-Modelle, die Mitglieder nutzen dürfen, wurde geändert.")
	return /** @type {LocalizedString} */ ("The set of AI models members may choose from was changed.")
});